var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 64,
    viewBox: "0 0 128 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Line 01",
    opacity: 0.2,
    d: "M128 64V0L123.848 5.76904C119.697 11.5375 111.396 23.0721 103.095 29.8008C94.7938 36.53 86.4922 38.4526 78.1906 32.6848C75.0281 30.4875 71.8656 27.1742 68.7031 23.8608C63.564 18.4766 58.425 13.0923 53.2859 12.4971C46.0913 11.6639 38.8967 20.2174 31.7021 28.7709C30.5951 30.0869 29.4882 31.403 28.3812 32.6848C20.0797 42.298 11.7781 49.9885 3.47656 51.9111C2.31771 52.1795 1.15885 52.3355 0 52.3791V64H128Z",
    fill: "#17B26A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.478c70800ea2a8e963832b6570a9c746.svg";
export { ForwardRef as ReactComponent };